import { Helmet } from 'react-helmet';
import CompanyHistory from '../components/about/CompanyHistory';
import MissionVision from '../components/about/MissionVision';
import Sustainability from '../components/about/Sustainability';

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About VEDUS | Our Story, Mission & Vision</title>
        <meta name="description" content="Learn about VEDUS Supply Chain Management's 30+ years of expertise in global and domestic logistics, our mission, vision, and sustainability commitments." />
      </Helmet>
      
      <div className="bg-secondary-900 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">About VEDUS</h1>
          <p className="text-xl text-secondary-300 max-w-3xl mx-auto">
            With Professionals over 30 years of expertise in global and domestic logistics, VEDUS has established itself as a trusted partner for businesses seeking reliable supply chain solutions.
          </p>
        </div>
      </div>
      
      <CompanyHistory />
      <MissionVision />
      <Sustainability />
    </>
  );
};

export default AboutPage;